/**
 * /files — File Explorer landing.
 *
 * When the user picks the "Files" contour in the ActivityBar the Shell
 * navigates here. This route renders the right-pane viewer; the tree
 * lives inside the Sidebar variant and pipes selections back through
 * the URL (`/files/$/...`).
 *
 * Pathless empty state when nothing is selected — single muted line per
 * UI guidelines §7.
 */
import { createFileRoute } from '@tanstack/react-router';

import { FileViewer } from '../../components/files/file-viewer';

function FilesIndex() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <FileViewer />
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/files')({
  component: FilesIndex,
});
